import { CHANGE_PARTICIPANTS_SORT } from "./constants";

export const changeParticipantSort = (column, direction) => ({
  type: CHANGE_PARTICIPANTS_SORT,
  payload: {
    column,
    direction,
  },
});
